import styled from 'styled-components';

const LargeList = styled.ul`
    padding: 22px;
`;

const LargeListItem = styled.li`
    width: 796px;
    background: #ffffff;
    box-shadow: 0px 0px 2px rgba(0, 0, 40, 0.5);
    border-radius: 16px;
    padding: 16px 32px;

    &:not(:last-child) {
        margin-bottom: 16px;
    }
    a {
        text-decoration: none;
        color: black;
    }
`;

export const List = { LargeList, LargeListItem };
